import { atom } from "recoil"

const notificationState = atom({
  key: "notification", 
  default: []
})

export default notificationState
